"use strict";
exports.__esModule = true;
exports.KushkiCardinalSandbox = void 0;
/**
 * KushkiCardinalSandbox class
 */
var EnumEvent_1 = require("./../../lib/core/infrastructure/EnumEvent");
var Modal3DS_1 = require("./../../lib/core/template/Modal3DS");
var Styles_1 = require("./../../lib/core/template/Styles");
var KushkiCardinalSandbox = /** @class */ (function () {
    function KushkiCardinalSandbox() {
    }
    KushkiCardinalSandbox.toogleClassErrorMessage = function (element, addAction) {
        if (addAction) {
            element.classList.add("show-error");
            return;
        }
        element.classList.remove("show-error");
    };
    KushkiCardinalSandbox.closeModal = function (callbackEvent) {
        var modal_element = (document.querySelector(".modal"));
        var input_otp = document.getElementById("txtOtp");
        if (callbackEvent)
            callbackEvent(true);
        input_otp.value = "";
        modal_element.style.display = "none";
    };
    KushkiCardinalSandbox.init = function () {
        var modal = document.createElement("div");
        modal.setAttribute("id", "sandbox3DSModal");
        modal.insertAdjacentHTML("beforeend", Styles_1["default"].concat(Modal3DS_1.modal3DS()));
        document.body.appendChild(modal);
        var button = document.getElementById("btnClose");
        var text_error = (document.getElementById("messageError"));
        button.addEventListener("click", function () {
            KushkiCardinalSandbox.toogleClassErrorMessage(text_error, false);
            KushkiCardinalSandbox.closeModal();
        });
    };
    KushkiCardinalSandbox["continue"] = function (_key, _parameters, _orderDetails) {
        var modal_element = (document.querySelector(".modal"));
        modal_element.style.display = "block";
    };
    KushkiCardinalSandbox.on = function (key, callbackEvent) {
        if (key !== EnumEvent_1.EnumEvent.VALIDATED)
            return;
        KushkiCardinalSandbox._submitModal(callbackEvent);
        var button = document.getElementById("btnClose");
        var text_error = (document.getElementById("messageError"));
        button.addEventListener("click", function () {
            KushkiCardinalSandbox.toogleClassErrorMessage(text_error, false);
            KushkiCardinalSandbox.closeModal(callbackEvent);
        });
    };
    KushkiCardinalSandbox._submitModal = function (callbackEvent) {
        var btn_submit = document.getElementById("btnSubmit");
        var txt_otp = (document.getElementById("txtOtp"));
        var text_error = (document.getElementById("messageError"));
        var is_error_flow = true;
        btn_submit.addEventListener("click", function () {
            if (txt_otp.value === "9999") {
                KushkiCardinalSandbox.toogleClassErrorMessage(text_error, false);
                KushkiCardinalSandbox.closeModal();
                return callbackEvent(is_error_flow);
            }
            if (txt_otp.value !== "1234") {
                KushkiCardinalSandbox.toogleClassErrorMessage(text_error, true);
                return;
            }
            var modal = document.getElementById("sandbox3DSModal");
            document.body.removeChild(modal);
            KushkiCardinalSandbox.toogleClassErrorMessage(text_error, false);
            callbackEvent();
        });
    };
    return KushkiCardinalSandbox;
}());
exports.KushkiCardinalSandbox = KushkiCardinalSandbox;
